//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import MaterialInput from "@Shared/components/inputs/material-input.vue";
import SimpleButton from "@Shared/components/buttons/simple-button.vue";
import { validationMixin } from "vuelidate";
import { required, email } from "vuelidate/lib/validators";
import { postAccountsApi } from "@Shared/@Utils/ajax";
import Err from "@Client/@Routes/error";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "PasswordDetails",
  components: {
    SimpleButton,
    MaterialInput
  },
  mixins: [validationMixin],
  validations: {
    emailReset: {
      required,
      email
    }
  },
  data() {
    return {
      loading: false,
      loadingStatus: true,
      emailReset: ""
    };
  },
  computed: {
    isValid() {
      return !this.$v.$invalid;
    }
  },
  methods: {
    async handleSubmit() {
      if (!this.isValid) return;
      try {
        this.loading = true;
        await postAccountsApi({
          email: this.emailReset
        }, "/reset-password");
        this.loadingStatus = true;
        this.loading = false;
        this.$emit("next-page", {
          page: "password-verify",
          email: this.emailReset
        });
      } catch (e) {
        this.loadingStatus = false;
        this.loading = false;
        Err.handle(e);
      }
    }
  }
});